module.exports = __webpack_public_path__ + "img/dataFile.059eaf7e.png";